/* eslint-disable no-shadow */

import React  from 'react';
import { Menu, message } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { logout, switchLanguage } from '../../actions';

import {loadJson} from '../../utils/loadjson';
const homeLayout = loadJson( '/assets/home.json');
const showLangMenu = homeLayout.showLangMenu;

const Flag = styled.div`
  background-image: url(${props => props.src});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 20px;
  border: ${props => (props.selected ? '2px solid white' : 'none')};
  width: 30px;
  display: inline-block;
`;

const TopBar = withRouter(({ user, history, logout, intl, switchLanguage }) => (
  <Menu
    mode="horizontal"
    theme="dark"
    style={{ lineHeight: '35px' }}
    className='only-desktop'
    selectedKeys={[intl.locale === 'en' ? 'ta' : 'tv']}
  >
    {
      !user.isAuth
        ? <div style={{ height: 1 }} />
        : (
          <Menu.SubMenu style={{ fontSize: '12px', float: 'right' }} title={user.info.fullname} key="user">
            <Menu.Item key="ql"><Link to="/dashboard"><FormattedMessage id="TopBar.Dashboard" /></Link></Menu.Item>
            <Menu.Item
              key="dx"
              onClick={() =>
                logout(() => {
                  message.success('Đăng xuất thành công');
                  history.push('/');
                })
              }
            >
              <FormattedMessage id="TopBar.Logout" defaultMessage="Đăng xuất" />
            </Menu.Item>
          </Menu.SubMenu>
        )
    }
   { showLangMenu &&
   <Menu.SubMenu
      style={{ fontSize: '12px', float: 'right', paddingTop: 7.5, paddingBottom: 7.5 }}
      className="xxxxx"
      title={<Flag selected src={intl.locale === 'vi' ? '/assets/images/VN.png' : '/assets/images/GB.png'} />}
      key="ngon-ngu"
    >
      <Menu.Item
        onClick={() => switchLanguage('vi')}
        key="tv"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}
      >
        <Flag style={{ marginRight: 10 }} selected src='/assets/images/VN.png' />
        <FormattedMessage id="TopBar.Vietnamese" />
      </Menu.Item>
      <Menu.Item
        onClick={() => switchLanguage('en')}
        key="ta"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}
      >
        <Flag style={{ marginRight: 10 }} selected src='/assets/images/GB.png' />
        <FormattedMessage id="TopBar.English" />
      </Menu.Item>
    </Menu.SubMenu>  
    }
  </Menu>
));

const mapStateToProps = state => ({
  user: state.user,
  intl: state.intl,
});

const mapDispatchToProps = {
  logout,
  switchLanguage,
};

export default connect(mapStateToProps, mapDispatchToProps)(TopBar);



// WEBPACK FOOTER //
// ./src/components/layouts/TopBar.js